import {language as lan_storeStatusIcon} from "./store-status-icon";

let language = {
    // 店铺状态、店铺连接状态
    ...lan_storeStatusIcon,
    
    STORE_PRODUCT_FILTER_STORE_DES:"Select a store to view, edit, add, or remove products.",
    STORE_PRODUCT_FILTER_STORE_TITLE:"Store:",
    STORE_PRODUCT_FILTER_PRODUCT_SEARCH_TIP:"Special characters are not supported"

};

export { language }